import { Component, Input, OnInit } from '@angular/core';
import { ProgressTimelineType } from '../../../../model/kamonal-model';

@Component({
	selector: 'app-time-line-progress',
	templateUrl: './time-line-progress.component.html',
	styleUrls: ['./time-line-progress.component.scss'],
})
export class TimeLineProgressComponent implements OnInit {
	@Input() totalStep: number;
	@Input() currentStep: number;
	@Input() type: ProgressTimelineType;
	@Input() percentage: number;
	@Input() size = 58;
	@Input() strokeWidth = 10;
	@Input() minute: any;
	@Input() second: any;
	@Input() totalTime: any;
	@Input() currentTime: any;
	@Input() strokeColor = '#0361F0';
	@Input() useLargeFont = false;
	@Input() isTimerHidden= false;
	readonly LARGE_TITLE_FONT_CLASS = 'text-[20px] leading-[24px]';
	readonly LARGE_DES_FONT_CLASS = 'text-[14px] leading-[17px]';
	readonly DEFAULT_TITLE_FONT_CLASS = 'text-xl';
	readonly DEFAULT_DES_FONT_CLASS = 'text-sm';
	ProgressTimelineType = ProgressTimelineType;
	readonly TOTAL_PERCENTAGE = 100;

	constructor() {}

	ngOnInit(): void {
		if (!this.type) {
			this.type = ProgressTimelineType.REGULAR;
		}
	}

	formatTime(time) {
		return time > 0 ? time : `0${time}`;
	}

	getCurrentStepProgress() {
		if (this.type === ProgressTimelineType.PERCENTAGE) {
			return this.percentage;
		}
		if (this.type === ProgressTimelineType.TIMER) {
			const denominator = this.totalTime;
			const numerator = this.currentTime;
			const progress = (numerator / denominator) * this.TOTAL_PERCENTAGE;
			return Math.round(progress);
		}
		return (this.currentStep / this.totalStep) * this.TOTAL_PERCENTAGE;
	}
}
